module.exports = __webpack_public_path__ + "static/media/upload-title.e85ed913.svg";